import Cookies from 'js-cookie'
import { httpClient, httpGWClient } from '@/services'
import { debugText, isProd } from '@/helpers'

const APP_VERIFY_ENTRY = process.env.APP_VERIFY_ENTRY
const ACCOUNT_USER_NOT_REGISTER = -1

function toWeixinAuthorization (callbackUrl) {
  // 1. non register user logic
  goTo(`${APP_VERIFY_ENTRY}?targeturl=${encodeURIComponent(callbackUrl.toString())}`)

  throw new Error('wx authorization')
}

function goTo (link) {
  window.location.href = link
}

/**
 * @param oneAppConfig {OneAppConfig}
 * @return {Promise<void>}
 */
async function verifyUserToken (oneAppConfig) {
  if (!oneAppConfig) {
    throw new Error('[oneAppConfig] 应用配置载入错误 .')
  }

  const url = new URL(window.location.href)
  const { accountInfo } = oneAppConfig

  console.log('[Account Info111]', accountInfo, location.href.includes('interest'))
  if (accountInfo && accountInfo.openid && location.href.includes('interest')) {
    // TODO: Success
    console.debug('[Account Info]', accountInfo)
    return
  }

  if (accountInfo && accountInfo.account_id) {

    const accountId = parseInt(accountInfo.account_id)
    if(!location.href.includes('interest')){
      switch (accountId) {
        // 0. TODO: is register user ?
        case ACCOUNT_USER_NOT_REGISTER:
          stopFatalWhenVerified(url)
          await resolveRegisterService()
          // eslint-disable-next-line prefer-promise-reject-errors
          return Promise.reject('[account error] ACCOUNT_USER_NOT_REGISTER')
      }
    }
   
    // TODO: Success
    console.debug('[Account Info]', accountInfo)
    return
  }

  stopFatalWhenVerified(url)
  toWeixinAuthorization(url)

  function stopFatalWhenVerified (url) {
    if (url.searchParams.get('ref') === 'verify') {
      const e = new Error('[account info -1] STOP with verifying callback error .')

      debugText(e,
        `[TOKEN] ${JSON.stringify(Cookies.get())} <br><br>
            ${JSON.stringify(oneAppConfig)} <br><br> 
            <small>${document.cookie}</small>`)

      setTimeout(() => {
        Cookies.remove('yly_auth', {
          path: '/',
          domain: '.doctopia.com.cn'
        })

        debugText('[DELETE COOKie] yly_auth', '', true)

        // 尝试重新授权
        url.searchParams.delete('ref')

        if (!isProd) {
          if (window.confirm('确定是否再次授权')) {
            toWeixinAuthorization(url.toString())
          }

          return
        }

        // TODO: fix service logic
        toWeixinAuthorization(url.toString())
      }, 24)

      throw e
    }
  }

  async function resolveRegisterService () {
    const url = new URL(window.location.href)
    const code = url.searchParams.get('code') || 0
    try {
      await httpClient.get(`/assessuser/v1/assessment/${code}`)
    } catch (e) {
      if (e && e.response) {
        const { data } = e.response

        if (data && data.code.toString() === '10301') {
          const { registerUrl } = data.data

          const u = new URL(window.location.href)
          u.searchParams.append('ref', 'verify')

          const registerLink = `${registerUrl}${encodeURIComponent(u.toString().replace('code=', 'id='))}`

          if (!isProd) {
            window.alert(`[Debug] [未注册用户] 即将跳转到 ${registerLink} .`)
          }
          console.log('goTo', e)
          if (!location.href.includes('interest')) {
            goTo(registerLink)
          }

          throw new Error(`[Verify To Register] => ${registerUrl}`)
        }

        throw new Error(`[Verify Code Error] ${JSON.stringify(data)}`)
      }
    }
  }
}

/**
 * @returns {Promise<void>}
 */
async function createVendorUserToken (payload) {
  if (!payload || !payload.sign) {
    throw new Error('BAD Vendor payload .')
  }

  const res = await httpGWClient
    .get(`/v1/auth/otherLogin?${payload._url.toString()}`)

  if (!res || !res.data) {
    throw new Error('Bad Response .')
  }

  const { code, data } = res.data

  if (code == 400) {
    throw new Error(res.data.msg)
  }

  if (!data.yly_auth) {
    throw new Error('Bad Authorization .')
  }

  Cookies.set('yly_auth', data.yly_auth)
}

export {
  verifyUserToken,
  createVendorUserToken
}
